<template>
  <v-container class="financial-comissions-widget">
    <v-row class="financial-comissions-widget-row">
      <orderView
        v-if="order.selected"
        :value="order.selected"
        :dialog="order.dialog"
        @closed="onCloseOrder"
      />
      <v-col cols="12" lg="9" md="9" sm="12" class="financial-comissions-widget-col list">
        <v-row class="pa-0">
          <v-col cols="12" align="center" justify="space-around" class="filters-col pa-0">
            <v-btn
              @click.stop="changeDate(1)"
              text
              color="primary"
            >
              Última Semana
            </v-btn>

            <v-btn
              @click.stop="changeDate(2)"
              text
              color="primary"
            >
              Último Mês
            </v-btn>

            <v-btn
              @click.stop="changeDate(3)"
              text
              color="primary"
            >
              Último Ano
            </v-btn>
          </v-col>
          <v-col cols="1" class="filters-col py-7 px-3">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  color="grey darken-2"
                  @click="weekPage(0)"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.financial.salary.widget.filters.prev }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="5" class="filters-col px-0 py-3 pr-2">
            <v-menu
              v-model="filters.menu_s"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="190px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  :value="formatDate(filters.start, false)"
                  :label="lang.historic.filters.date_range.start"
                  prepend-icon="mdi-calendar-arrow-left"
                  readonly
                  filled
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.start"
                :max="filters.end"
                locale="pt-br"
                no-title
                @input="filters.menu_s = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="5" class="filters-col px-0 py-3 pl-2">
            <v-menu
              v-model="filters.menu_e"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="190px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-on="on"
                  v-bind="attrs"
                  :value="formatDate(filters.end, false)"
                  :label="lang.historic.filters.date_range.end"
                  prepend-icon="mdi-calendar-arrow-right"
                  readonly
                  filled
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.end"
                :max="filters.end"
                locale="pt-br"
                no-title
                @input="filters.menu_e = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="1" class="filters-col py-7 px-2">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  color="grey darken-2"
                  @click="weekPage(1)"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.financial.salary.widget.filters.next }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row class="pa-0">
          <v-col cols="1" class="filters-col pa-0"> </v-col>
          <v-col cols="10" align="center" justify="space-around" class="filters-col pa-2">
            <v-text-field
              v-model="filters.search"
              :label="lang.financial.salary.datatable.search"
              prepend-inner-icon="mdi-magnify"
              filled
              hide-details
              clearable
            />
          </v-col>
          <v-col cols="1" class="filters-col pa-0"> </v-col>
        </v-row>
        <v-row class="pa-0">
          <v-col cols="12" class="pa-0">
            <v-card
              class="toolbar-card"
              flat
              tile
            >
              <v-toolbar :elevation="0" :height="27" class="mini-toolbar">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      @click="selectAll()"
                      icon
                      small
                    >
                      <v-icon small>
                        mdi-checkbox-intermediate
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.order.toolbar.check_all }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      @click="deselectAll()"
                      icon
                      small
                    >
                      <v-icon small>
                        mdi-checkbox-blank-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.order.toolbar.uncheck_all }}</span>
                </v-tooltip>
                <v-divider
                  class="mx-1"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <span>
                  <v-progress-circular
                    color="indigo"
                    :value="100"
                    :size="9"
                    class="ml-1"
                  />
                  Produto
                </span>
                <v-divider
                  class="mx-2"
                  inset
                  vertical
                ></v-divider>
                <span>
                  <v-progress-circular
                    color="pink"
                    :value="100"
                    :size="9"
                    class="ml-1"
                  />
                  Serviço
                </span>
              </v-toolbar>
            </v-card>
          </v-col>
        </v-row>
        <v-list v-if="list.length > 0" dense>
        <v-list-item class="head">
            <v-list-item-content>
              <v-list-item-title>
                <v-row class="item-row">
                  <v-col class="item-col checkbox">
                    &nbsp;
                  </v-col>
                  <v-col class="item-col date">
                    Data
                  </v-col>
                  <v-col class="item-col employee">
                    Profissional
                  </v-col>
                  <v-col class="item-col customer">
                    Cliente
                  </v-col>
                  <v-col class="item-col list">
                    Lista
                  </v-col>
                  <v-col class="item-col order">
                    Pedido
                  </v-col>
                  <v-col class="item-col total">
                    Total
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(item, i) in list"
            :key="i"
            @click.stop="select_(item)"
            :class="{ 'selected': selected.findIndex(el => el[0] === item.id) >= 0 }"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-row class="item-row">
                  <v-col class="item-col checkbox">
                    <v-checkbox
                      :value="selected.findIndex(el => el[0] === item.id) >= 0"
                      @click.stop="select_(item)"
                      light
                      hide-details
                      class="pa-0 ma-0"
                    />
                  </v-col>
                  <v-col class="item-col date">
                    <span v-text="formatDate(item.datetime, true, true)" class="item-datetime" />
                  </v-col>
                  <v-col class="item-col employee">
                    <Employee :value="item.employee" noSpacing />
                  </v-col>
                  <v-col class="item-col customer">
                    <CustomerCard v-model="item.customer" hideCpf />
                  </v-col>
                  <v-col class="item-col list">
                    <div class="item-service">
                      <span>
                        <v-progress-circular
                          :color="(item.service.catalog === 'items' ? 'indigo' : 'pink')"
                          :value="100"
                          :size="9"
                          class="ml-1"
                        ></v-progress-circular>
                        {{ item.service.title }}
                      </span>
                      <span v-text="item.service.description" class="font-italic" />
                    </div>
                  </v-col>
                  <v-col class="item-col order">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          @click.stop="openOrder(item.order_obj)"
                          color="primary"
                          icon
                          x-small
                        >
                          <v-icon small>mdi-open-in-new</v-icon>
                        </v-btn>
                      </template>
                      <span v-text="lang.financial.salary.widget.view_order" />
                    </v-tooltip>
                  </v-col>
                  <v-col class="item-col total">
                    <span class="price-fraction">{{ `${item.percent}% de ${formatCurrency(item.service.price)}` }}</span><br />
                    <span class="price-total">{{ formatCurrency(item.value) }}</span>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <span class="empty-list" v-else>{{ lang.financial.salary.widget.empty }}</span>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12" class="financial-comissions-widget-col selected">
        <v-subheader>{{ lang.financial.salary.widget.selected }}</v-subheader>
        <div class="total_panel pa-2">
          <p><b>Total de Serviços:</b> {{ formatCurrency(total.services) }}</p>
          <p><b>Total de Comissões:</b> {{ formatCurrency(total.comissions) }}</p>
          <p><b>Total da Parte do Salão:</b> {{ formatCurrency(total.salon) }}</p>
        </div>
        <v-list dense>
          <v-list-item
            v-for="(item, i) in selected"
            :key="i"
            class="selected-list"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-row class="pa-0 selected-row">
                  <v-col cols="5" class="selected-col divider">
                    <v-subheader>Data:</v-subheader>
                    <span v-text="formatDate(item[1], true, true)" class="item-datetime" />
                  </v-col>
                  <v-col cols="7" class="selected-col">
                    <v-subheader>Lista:</v-subheader>
                    <div class="item-service">
                      <span>
                        <v-progress-circular
                          :color="(item[3].catalog === 'items' ? 'indigo' : 'pink')"
                          :value="100"
                          :size="9"
                          class="ml-1"
                        ></v-progress-circular>
                        {{ item[3].title }}
                      </span>
                      <span v-text="item[3].description" class="font-italic" />
                    </div>
                  </v-col>
                  <v-col cols="5" class="selected-col divider">
                    <v-subheader>Profissional:</v-subheader>
                    <Employee :value="item[2]" noSpacing />
                  </v-col>
                  <v-col cols="7" class="selected-col">
                    <v-subheader>Cliente:</v-subheader>
                    <CustomerCard v-model="item[8]" hideCpf />
                  </v-col>
                  <v-col cols="12" class="selected-col price-col">
                    <v-subheader>Total:</v-subheader>
                    <span class="price-fraction">{{ `${item[5]}% de ${formatCurrency(item[3].price)}` }}</span><br />
                    <span class="price-total">{{ formatCurrency(item[6]) }}</span>
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon 
                @click.stop="deselect_(item)"
                small
              >
                mdi-close-thick
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <!-- <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click.prevent="new_()"
              color="primary"
              x-small
              fab
              app
              bottom
              right
            >
              <v-icon small dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.financial.salary.widget.add }}</span>
        </v-tooltip> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DEFAULT_DATE, FIRST_DAY_WEEK, FIRST_DAY_MONTH, FIRST_DAY_YEAR } from '@/components/utils/daterange/constants'

import Employee from '@/components/users/templates/Employee'
import CustomerCard from '@/components/customers/templates/MiniCard'
import orderView from '@/components/orders/View'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import periodicals from '@/components/financial/periodicals/mixins/index'
import orders from '@/components/orders/mixins/index'

import moment from 'moment'
import { format, addDays, subDays, startOfWeek, endOfWeek } from 'date-fns'

export default {
  components: { Employee, CustomerCard, orderView },
  mixins: [ appdata, utils, periodicals, orders ],
  props: {
    value: {
      type: Array,
      required: true
    },
    editing: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      selected: [ ...this.value ],
      menu: false,
      filters: {
        start: FIRST_DAY_WEEK,
        end: DEFAULT_DATE,
        search: '',
        menu_s: false,
        menu_e: false
      },
      order: {
        selected: {},
        dialog: false
      },
      total: {
        salon: 0,
        services: 0,
        comissions: 0
      }
    }
  },
  computed: {
    list () {
      this.filters.search
      let data = (this.get_data || {}).financial || {},
          comissions = (data.comissions || [])
            .filter(co => {
              let is_between = moment(this.removeTimeFromDate(co.datetime)).isBetween(this.filters.start, this.filters.end, undefined, '[]')
              return (is_between ? (this.editing ? true : (co.paid === 0)) : false)
            })
            .filter(co => {
              let employee = (co.employee || {}).name,
                  cat_name = (co.service || {}).cat_name,
                  parent_cat_name = (co.service || {}).parent_cat_name,
                  title = (co.service || {}).title,
                  filterable = [
                    employee,
                    cat_name,
                    parent_cat_name,
                    title
                  ]
              return (this.filters.search !== '' ? JSON.stringify(filterable).toLowerCase().indexOf(this.filters.search.toLowerCase()) > -1 : true)
            })
            .map(co => {
              return {
                ...co,
                order_obj: this.getOrder(co.order),
                customer: this.getCustomer(co.customer_id),
              }
            })
      return comissions
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) {
          this.$emit('input', [ ...newVal ])
          this.updateTotal(newVal);
        }
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) {
          this.selected = [ ...newVal ]
          this.updateTotal(newVal);
        }
      }
    }
  },
  methods: {
    updateTotal (newVal) {
      console.log('updateTotal', newVal);
      let array = [ ...newVal ];
      let total_comissions = array.reduce((acc, curr) => {
        let value = Number(curr[6]);
        return acc + (isNaN(value) ? 0 : value);
      }, 0);
      total_comissions = parseFloat(total_comissions.toFixed(2));

      let total_services = array.reduce((acc, curr) => {
        let value = curr[3] && typeof curr[3].total !== 'undefined' ? Number(curr[3].total) : 0;
        return acc + (isNaN(value) ? 0 : value);
      }, 0);
      total_services = parseFloat(total_services.toFixed(2));

      let total_salon = parseFloat((total_services - total_comissions).toFixed(2));

      this.total.comissions = total_comissions;
      this.total.services = total_services;
      this.total.salon = total_salon;
    },
    getCustomer (id) {
      let customers = this.get_data.customers || []
      return customers.find(el => el.id === id) || false
    },
    changeDate(type) {
      let start = null,
          end = null
      switch (type) {
        case 1:
          start = FIRST_DAY_WEEK
          end = DEFAULT_DATE
          break
        case 2:
          start = FIRST_DAY_MONTH
          end = DEFAULT_DATE
          break
        case 3:
          start = FIRST_DAY_YEAR
          end = DEFAULT_DATE
          break
      }
      this.filters.start = start
      this.filters.end = end
    },
    weekPage (action) {
      var [ year_s, month_s, day_s ] = [ ...this.filters.start.split("-") ],
          [ year_e, month_e, day_e ] = [ ...this.filters.end.split("-") ],
          curr_s = new Date(year_s, month_s - 1, day_s),
          curr_e = new Date(year_e, month_e - 1, day_e),
          new_s = null,
          new_e = null
      if (action < 1) {
        new_s = startOfWeek(subDays(startOfWeek(curr_s), 1)),
        new_e = addDays(new_s, 7)
      } else {
        new_s = startOfWeek(addDays(endOfWeek(curr_e), 1)),
        new_e = addDays(new_s, 7)
      }
      this.filters.start = format(new_s, 'yyyy-MM-dd')
      this.filters.end = format(new_e, 'yyyy-MM-dd')
    },
    openOrder (order) {
      /* let routeData = this.$router.resolve({ name: 'orders:view', params: { id: order }})
      window.open(routeData.href, '_blank') */
      this.order.selected = { ...order }
      this.order.dialog = true
    },
    onCloseOrder () {
      this.order.selected = {}
      this.order.dialog = false
    },
    selectAll () {
      let list = this.list.map(co => {
        return [
          co.id,
          co.datetime,
          co.employee,
          co.service,
          co.order,
          co.percent,
          co.value,
          co.order_obj
        ]
      })
      this.selected = list
    },
    deselectAll () {
      this.selected = []
    },
    new_ () {
      let selected = this.selected || []
      selected.push([ 0, '', '', 0 ])
    },
    select_ (val) {
      let selected = this.selected || [],
          index = selected.findIndex(el => el[0] === val.id)
      if (index >= 0) {
        selected.splice(index, 1)
      } else {
        // selected.push({ ...val })
        selected.push([ val.id, val.datetime, val.employee, val.service, val.order, val.percent, val.value, val.order_obj, val.customer ])
      }
    },
    deselect_ (val) {
      let selected = this.selected || [],
          index = selected.indexOf(val)
      selected.splice(index, 1)
    },
    formatCurrency(value) {
        return parseFloat(value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    }
  },
  mounted () {
    this.updateTotal(this.selected);
  }
}
</script>

<style lang="scss" src="./styles/comissions.scss" />